import moment from 'moment';

const getSortPriority = (value: any): number => {
  if (!value) return 2;
  const num = Number(value);
  return num < 0 ? 0 : 2;
};

export const priorityNumberSortingFn = (rowA: any, rowB: any, columnId: string) => {
  const aVal = rowA.getValue(columnId);
  const bVal = rowB.getValue(columnId);
  const aPriority = getSortPriority(aVal);
  const bPriority = getSortPriority(bVal);
  if (aPriority !== bPriority) {
    return aPriority - bPriority;
  }
  const aNum = Number(aVal);
  const bNum = Number(bVal);
  if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
    return aNum - bNum;
  }
  return String(aVal || '')
    .toLowerCase()
    .localeCompare(String(bVal || '').toLowerCase());
};

export const arrayFirstElementSortingFn = (rowA: any, rowB: any, columnId: string) => {
  const aVal = rowA.getValue(columnId);
  const bVal = rowB.getValue(columnId);

  if (Array.isArray(aVal) && Array.isArray(bVal)) {
    const aFirst = Number(aVal[0] || 0);
    const bFirst = Number(bVal[0] || 0);
    return aFirst - bFirst;
  }

  return String(aVal || '').localeCompare(String(bVal || ''));
};

export const insuredLenderNameSortingFn = (rowA: any, rowB: any, columnId: string) => {
  const aVal = rowA.getValue(columnId);
  const bVal = rowB.getValue(columnId);

  const aName = (aVal as any)?.englishName || (aVal as any)?.frenchName;
  const bName = (bVal as any)?.englishName || (bVal as any)?.frenchName;

  return String(aName || '')
    .toLowerCase()
    .localeCompare(String(bName || '').toLowerCase());
};

export const momentDateSortingFn = (rowA: any, rowB: any, columnId: string) => {
  const aVal = rowA.getValue(columnId);
  const bVal = rowB.getValue(columnId);

  const dateA = moment(String(aVal), 'YYYY-MM-DD');
  const dateB = moment(String(bVal), 'YYYY-MM-DD');

  if (dateA.isValid() && dateB.isValid()) {
    return dateA.diff(dateB);
  }
  return String(aVal || '').localeCompare(String(bVal || ''));
};
